<template>
  <div>

    <a-row class="mt-20">
      <a-col :span="14" :offset="3">
        <a-form-item label="Engagement (s)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
          <a-button type="dashed" block @click="addEngagement">
            + Add Engagement
          </a-button>
        </a-form-item>
      </a-col>
    </a-row>


    <a-row>
      <a-col :span="20" :offset="2">
        <!-- list form  -->
        <a-form :layout="'horizontal'">
          <a-list class="demo-loadmore-list" item-layout="horizontal" :loading="loading"
            :data-source="dataEngagements.slice().reverse()">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <p slot="title" class="mt-0 mb-0">
                  <!-- <pre>{{ item }}</pre> -->
                </p>
                <div slot="description">
                  <a-row>
                    <a-col class="text-center" :span="20">
                      <a-row>
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Activity Name : </h6>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ?
                            item.engement_activity_detail.name_of_activity : '' }}</p>
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Date of Activity : </h6>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ?
                            item.engement_activity_detail.date_of_activity : '' }}</p>
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Role and Duty in the activity : </h6>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{
                            item.role_and_duty_in_the_activity_detail ? item.role_and_duty_in_the_activity_detail.name_eng
                            :
                            item.role_and_duty_in_the_activity_other }}</p>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Donation : </h6>
                        </a-col>
                        <a-col :span="12">
                          <div class="mt-5 mb-0">
                            <span>
                              Charity : {{ item.amount_charity }}
                            </span><br />
                            <span>
                              Fee : {{ item.amount_fee }}
                            </span><br />
                            <span>
                              Sponsorship : {{ item.amount_sponsorship }}
                            </span>
                          </div>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Items : </h6>
                        </a-col>
                        <a-col :span="12">
                          <span class="mt-5 mb-0" v-for="(item, index) in item.item_detail" :key="index"
                            :value="item.value">
                            {{ item.item_detail + " " + item.amount }}
                            {{ index != item.item_detail.length - 1 ? "," : "" }}
                          </span>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Organized by : </h6>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ?
                            item.engement_activity_detail.organized_by : '' }}</p>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Location : </h6>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ? item.engement_activity_detail.location :
                            '' }}</p>
                        </a-col>
                      </a-row>

                    </a-col>
                    <a-col :span="2">
                      <a-button class="mr-5" type="" icon="edit" size="small"
                        @click="onShowModal('engagementEdit', item, index)" />
                      <a-popconfirm title="Are you sure to Delete？" @confirm="removeData(item.id)">
                        <a-icon slot="icon" type="question-circle-o" style="color: red" />
                        <a-button type="danger" icon="delete" size="small"></a-button>
                      </a-popconfirm>
                    </a-col>
                  </a-row>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-form>
      </a-col>
    </a-row>

    <!-- Modal component -->
    <span v-if="isShowModal">
      <engagementEdit :viewModal="isShowModal" :onShowModal="onShowModal" :onCloseModal="onCloseModal"
        :dataEngagement="dataEngagement" @updateTableData="updateTableData"></engagementEdit>
    </span>

    <!-- btn action -->
    <!-- <a-row class="mt-20">
        <a-col :span="10" :offset="5">
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button
              :disabled="btnSubmitLoad"
              type="primary"
              class="mr-10"
              @click="onSubmitEducation"
            >
              <a-spin v-if="btnSubmitLoad" class="mr-10" /> Submit
            </a-button>
            <a-button type="danger" @click="backTomain"> Back </a-button>
          </a-form-item>
        </a-col>
      </a-row> -->
  </div>
</template>
  
<script>
import engagementEdit from "./modal/EngagementEdit.vue";
export default {
  props: {
    dataProfile: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // option form
      optionMajor: [],
      optionType: [],
      optionCountry: [],
      btnSubmitLoad: false,
      isShowModal: false,
      currentModalComponent: 'engagementEdit',
      dataEngagements: []
    };
  },
  async mounted() {
    this.getEngagement();
    // this.getDataOption();
  },
  components: {
    engagementEdit,
  },
  methods: {
    updateTableData({ updateData, idRecordTable }) {
      this.getEngagement();
      //this.dataEngagements[idRecordTable] = updateData
    },
    backTomain() {
      this.$router
        .push({
          path: "/alumni/",
        })
        .catch((err) => { });
    },
    addEngagement(){
      this.$router
        .push({
          path: "/engagement/record/",
          query: { profile_id_callback: this.dataProfile[0].id }
        })
        .catch((err) => { });
    },
    async getEngagement() {
      this.loading = true
      this.dataEngagements = [];
      try {
        const res = await this.$http.get(
          `/student_affair/engagement-record/?search=${this.dataProfile[0].student_id}`
        );
        if (res.status === 200) {
          this.dataEngagements = res.data.map((item) => ({ ...item }));
          this.loading = false
        } else {
          throw { res };
        }
      } catch (error) {
        this.loading = false
        this.dataEngagements = [];
        this.notificationDialog(
          "#ff1919",
          "#ffffff",
          `Error ${error.response.status}`,
          `Problem issue connect api : /student_affair/alumni-award/?alumni_profile__student_id=${this.dataProfile[0].student_id}`
        );
      }
    },
    async removeData(idDel) {
      try {
        const res = await this.$http.delete(
          `/student_affair/engagement-record/${idDel}/`
        );
        if (res.status === 204) {
          this.getEngagement();
        } else {
          throw { res };
        }
      } catch (error) {
        this.$emit("errorNotification", {
          errorMsg: error.response.status,
          urlPath: `/student_affair/engagement-record/${idDel}/`,
        });
        this.$emit("search", {
          dataQuery: this.formSearchReport,
        });
      }
    },
    onShowModal(modal, recData, idRecordTable) {
      this.isShowModal = true;
      this.currentModalComponent = modal
      this.dataEngagement = null
      let activity_name = ''
      let std_id = ''
      let obj_std_name = ''
      try {
        activity_name = recData.engement_activity_detail.name_of_activity
        std_id = recData.alumni_profile_detail.student_id
        obj_std_name = recData.alumni_profile_detail.name_detail.length > 0 ?
          recData.alumni_profile_detail.name_detail[recData.alumni_profile_detail.name_detail.length - 1] : {}
      } catch (e) {
        //console.log(e)
      }
      // //console.log(obj_std_name)
      let formEngagement = {
        donation_fee: recData.amount_fee,
        donation_sponsorship: recData.amount_sponsorship,
        donation_charity: recData.amount_charity,
        role_and_duty: recData.role_and_duty_in_the_activity,
        other_role: recData.role_and_duty_in_the_activity_other,
        items: recData.item_detail,
      };
      let formDetail = {
        id: recData.id,
        id_rec_table: idRecordTable,
        activity_name: activity_name,
        std_id: std_id,
        std_name: this.filterBlankField(obj_std_name.title_name_detail.name_eng) + ' ' + this.filterBlankField(obj_std_name.eng_first_name) + ' ' + this.filterBlankField(obj_std_name.eng_middle_name) + ' ' + this.filterBlankField(obj_std_name.eng_last_name),
      }
      let concatJsonForm = Object.assign(formEngagement, formDetail)
      this.dataEngagement = Object.assign({}, concatJsonForm)
      // //console.log(this.dataEngagement)
    },
    setDefaultEducation() {
      if (this.dataProfile[0].education_detail.length !== 0) {
        this.arrEdu = this.dataProfile[0].alumin_education;
        this.educationItems = this.dataProfile[0].education_detail;
      }
    },
    async getDataOption() {
      this.loading = true
      const fetchMajor = await this.$http.get(`/student_affair/major/`);
      const fetchType = await this.$http.get(
        `/student_affair/education-graduate/`
      );
      const fetchCountry = await this.$http.get(
        `/student_affair/country-of-citizenship/`
      );
      Promise.all([fetchMajor, fetchType, fetchCountry])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC]) => {
          this.optionMajor = listA.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng} ${item.name_thai}`,
              value: item.id,
            };
          });
          this.optionType = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionCountry = listC.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `fail call option list`,
          });
        });
      this.setDefaultEducation();
      this.loading = false
    },
    filterBlankField(val) {
      return (val && val != '-') ? val : ''
    },
    onCloseModal() {
      // this.onSearchReport();
      this.isShowModal = false;
    },
  },
};
</script>
  